module.exports = {
  en: {
    path: 'en',
    locale: 'English',
    default: true,
  },
  fr: {
    path: 'fr',
    locale: 'Français',
  },
  de: {
    path: 'de',
    locale: 'Deutsch',
  },
  pt: {
    path: 'pt',
    locale: 'Português',
  },
}
